import { useEffect, useState } from 'react';

const KEY = 'ssl_cart';
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };
const write = (items) => { localStorage.setItem(KEY, JSON.stringify(items)); window.dispatchEvent(new Event('ssl-cart')); };

export const cart = {
  items: read,
  add(p, qty = 1) {
    const items = read();
    const i = items.find((x) => x.product_id === p.product_id);
    if (i) i.qty = Math.min(i.qty + qty, p.stock || 99);
    else items.push({ product_id: p.product_id, name: p.name, price: p.price, image_url: p.image_url, size: p.size, seller_id: p.seller_id, seller_name: p.seller_name, stock: p.stock, qty });
    write(items);
  },
  setQty(id, qty) { write(read().map((x) => (x.product_id === id ? { ...x, qty: Math.max(1, qty) } : x))); },
  remove(id) { write(read().filter((x) => x.product_id !== id)); },
  clear() { write([]); },
};

export function useCart() {
  const [items, setItems] = useState(read);
  useEffect(() => { const h = () => setItems(read()); window.addEventListener('ssl-cart', h); return () => window.removeEventListener('ssl-cart', h); }, []);
  const count = items.reduce((a, b) => a + b.qty, 0);
  const total = items.reduce((a, b) => a + b.qty * b.price, 0);
  return { items, count, total };
}

export const imgSrc = (u) => (u && u.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
